import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";

import { DropDownItemService } from "../services/dropdownitem.service";
import { IDropDownItemViewEdit } from "../interfaces/idropdowns";

@Injectable()
export class DropDownItemResolver implements Resolve<IDropDownItemViewEdit> {
    constructor(private dropDownItemService: DropDownItemService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IDropDownItemViewEdit> {
        return this.dropDownItemService.getDropDownItem(route.params["id"]);
    }
}
